import React, { Fragment }  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
    section: {
        marginBottom: theme.spacing(3)
    },
    success: {
        color: theme.palette.success.dark
    }
}));

export default function Step3(props) {

    const { app, setLoading, refreshClub, stripeClub } = props;

    const classes = useStyles();

    const businessType = () => {
        switch (stripeClub.stripe_account.business_type) {
            case 'individual':
                return 'Individual';
            case 'business':
                return 'Business';
            case 'non_profit':
                return 'Non-Profit';
            case 'government_entity':
                return 'Government Entity'
        }
    }

    const pendingVerification = stripeClub.stripe_account.requirements.pending_verification;

    return (
        <form>
            <Typography variant="h6" component="h2" className={classes.section}>
                <span className={classes.success}>Congratulations,</span> you are ready to begin accepting payments.
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" className={classes.section}>
                You are now ready to receiving payments from your members and guests online. Below are the details of your connected account for your records.
            </Typography>
            <Typography variant="subtitle2" className={classes.section}>Account Information:</Typography>
            <Grid container spacing={1} className={classes.section}>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Account ID:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_account.id}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Charges Enabled:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_account.charges_enabled ? 'Yes' : 'No'}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Payouts Enabled:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_account.payouts_enabled ? 'Yes' : 'No'}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Pending Verification:</Typography>
                </Grid>
                <Grid item xs={8}>
                    {pendingVerification.length ? pendingVerification.map(item => (
                        <Typography variant="body2" component="div">
                            {item}
                        </Typography>
                    )) : "None"}
                </Grid>
                {stripeClub.stripe_account.requirements.disabled_reason &&
                    <Fragment>
                        <Grid item xs={4}>
                            <Typography color="textSecondary" variant="body2">Disabled Reason:</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="subtitle2" component="div" color="error">
                                {stripeClub.stripe_account.requirements.disabled_reason}
                            </Typography>
                        </Grid>
                    </Fragment>
                }
            </Grid>
            <Typography variant="subtitle2" className={classes.section}>Business Profile:</Typography>
            <Grid container spacing={1} className={classes.section}>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Business Type:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {businessType()}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Name:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_account.business_profile.name}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Description:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_account.business_profile.product_description}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Currency:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_account.default_currency}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Country:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_account.country}
                    </Typography>
                </Grid>
            </Grid>
            <Typography variant="subtitle2" className={classes.section}>Representative Profile:</Typography>
            <Grid container spacing={1} className={classes.section}>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Name:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_representative_account.first_name + " " + stripeClub.stripe_representative_account.last_name}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Email:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_representative_account.email}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Phone:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_representative_account.phone}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Date of Birth:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_representative_account.dob.month + '/' + stripeClub.stripe_representative_account.dob.day + '/' + stripeClub.stripe_representative_account.dob.year  }
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Title:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_representative_account.relationship.title}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="textSecondary" variant="body2">Status:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {stripeClub.stripe_representative_account.verification.status}
                    </Typography>
                </Grid>
            </Grid>
            <Typography variant="h6" component="h2" className={classes.section}>
                Next Steps:
            </Typography>
            <Button
                margin="normal"
                component={Link}
                to="/admin/accounting"
                color="primary"
                >
                Back to the Accounting Dashboard
            </Button><br/>
            <Button
                margin="normal"
                component={Link}
                to="/admin/accounting/invoices/0"
                color="primary"
                >
                Create your first Invoice
            </Button><br/>
            <Button
                margin="normal"
                component={Link}
                to="/admin/levels"
                color="primary"
                >
                Add Regularly Invoiced Dues to Membership Levels
            </Button>
        </form>

    )
}
